import React from 'react'
import { IonLoading } from '@ionic/react'
import { useSelector } from 'react-redux'
import { getLoaderSelector } from './selectors'

const Loader: React.FC = () => {
  const loaderState = useSelector(getLoaderSelector)
  const { isOpen, showBackdrop = true, message = '', spinner = 'crescent' } = loaderState

  return <IonLoading isOpen={isOpen} animated showBackdrop={showBackdrop} message={message} spinner={spinner} />
}

export default Loader
